import React, { useContext, useEffect, useState } from 'react';
import validationSchema from '../New/validationSchema';
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Hidden,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Card,
  CardContent,
  CardActions,
  Divider,
  Chip,
  Tooltip,
  Box,
  Typography,
  Radio,
  RadioGroup,
  Tabs,
  Tab,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Field, Form, Formik } from 'formik';
import SearchIcon from '@material-ui/icons/Search';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import CategoryIcon from '@material-ui/icons/Category';
import TuneIcon from '@material-ui/icons/Tune';
import StorefrontIcon from '@material-ui/icons/Storefront';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme, makeStyles } from '@material-ui/core/styles';

import { format, isValid } from 'date-fns';

import { emptyObject, formattedDateTimeIso } from '../../../utils/utils';
import useApi from '../../../utils/useApi';
import StoreContext from '../../Store/context';

import UIButtonSearch from '../../UI/Button/Search/Search';
import UIModalFilter from '../../UI/ModalFilter/UIModalFilter';
import UIContainer from '../../UI/Container/UIContainer';
import UIFormTitle from '../../UI/Form/Title/UIFormTitle';
import UIFilter from '../../UI/Button/Filter/UIFilter';
import UIDialogConfirm from '../../UI/Dialog/Confirm/UIDialogConfirm';
import UIDialogTitle from '../../UI/Dialog/Title/UIDialogTitle';
import GreenSwitch from '../../UI/Form/Switch/GreenSwitch';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 12,
    minHeight: 620,
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      margin: 0,
      width: '100%',
      height: '100%',
      minHeight: '100%',
      maxHeight: 'none',
      borderRadius: 0,
    },
  },
  dialogContentStable: {
    flex: 1,
    minHeight: 460,
    padding: theme.spacing(2.5, 3),
    overflowY: 'auto',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 1.5),
      minHeight: 'auto',
    },
  },
  tabRoot: {
    minHeight: 52,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      padding: '6px 4px',
      minWidth: 'auto',
    },
  },
}));

const initialState = {
  id: '',
  name: '',
  description: '',
  customerProfile: null,
  discount: 0,
  interestFree: '',
  isActive: false,
  percentage: 0,
};

const initialClick = {
  mouseX: null,
  mouseY: null,
};

const PromotionSearch = () => {
  const classes = useStyles();
  const { credencials } = useContext(StoreContext);

  // verificar se é mobile
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  // modal ativar/desativar promoção
  const [modalActive, setModalActive] = useState(false);

  // mensagem de confirmação para operações
  const [alert, setAlert] = useState(false);
  const [alertActive, setAlertActive] = useState(false);

  // modais de pesquisa e filtragem
  const [view, setView] = useState(false);
  const [filter, setFilter] = useState(false);

  // salvar valores para modalde visualizar/alterar
  const [modalValues, setModalValues] = useState({});
  const [modalTab, setModalTab] = useState(0);

  // salvar valores do form de pesquisa
  const [search, setSearch] = useState({ isActive: 1 });
  // verificar se é ativo ou nao na "chavinha"
  const [isActive, setIsActive] = useState(false);

  // provider do click do lado direito
  const [clickRight, setClickRight] = useState(initialClick);

  const [paymentsLoad, paymentsInfo] = useApi({
    method: 'get',
    url: '/payments/methods',
    headers: {
      sessionToken: credencials.sessionToken,
      company: credencials.company,
    },
  });

  const [productsLoad, productsInfo] = useApi({
    method: 'get',
    url: '/products?lacking=0',
    headers: {
      sessionToken: credencials.sessionToken,
      company: credencials.company,
    },
  });

  const [servicesLoad, servicesInfo] = useApi({
    method: 'get',
    url: '/services?isActive=1',
    headers: {
      sessionToken: credencials.sessionToken,
      company: credencials.company,
    },
  });

  const [categoriesLoad, categoriesInfo] = useApi({
    method: 'get',
    url: '/categories',
    headers: {
      sessionToken: credencials.sessionToken,
      company: credencials.company,
    },
  });

  const parsePromoValues = (values) => {
    let payMethods = [];
    if (values.paymentMethods) {
      if (typeof values.paymentMethods === 'string') {
        try {
          payMethods = JSON.parse(values.paymentMethods);
        } catch (e) {
          payMethods = [];
        }
      } else if (Array.isArray(values.paymentMethods)) {
        payMethods = values.paymentMethods;
      }
    }

    const parseList = (val) => {
      if (!val) return [];
      if (typeof val === 'string') {
        try {
          const parsed = JSON.parse(val);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      if (Array.isArray(val)) return val;
      return [];
    };

    const rawCategories = parseList(values.categories);
    const rawProducts = parseList(values.products);
    const rawServices = parseList(values.services);

    const isPub = values.isPublic === 1 || values.isPublic === true || values.isPublic === '1';
    const isCoup = Boolean(values.couponCode && String(values.couponCode).trim());

    const isPct = Number(values.percentage) > 0 || (Number(values.discount) === 0 && Number(values.percentage) === 0);

    const formatDateTimeLocal = (dateStr) => {
      if (!dateStr) return '';
      try {
        const str = String(dateStr).trim();
        // Handle DD-MM-YYYY HH:mm:ss or DD/MM/YYYY HH:mm:ss
        if (/^\d{2}[-/]\d{2}[-/]\d{4}/.test(str)) {
          const [datePart, timePart] = str.split(' ');
          const [day, month, year] = datePart.split(/[-/]/);
          const time = (timePart || '00:00').slice(0, 5);
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${time}`;
        }
        // Handle YYYY-MM-DD HH:mm:ss
        if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}/.test(str)) {
          return str.replace(' ', 'T').slice(0, 16);
        }
        // Already ISO YYYY-MM-DDTHH:mm
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str)) {
          return str.slice(0, 16);
        }
        const d = new Date(str);
        if (isNaN(d.getTime())) return '';
        return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
      } catch (e) {
        return '';
      }
    };

    const resolvedPaymentMethods = externalPaymentMethods.filter((pm) =>
      payMethods.some((val) => String(typeof val === 'object' ? val.id : val) === String(pm.id))
    );
    const resolvedCategories = (categoriesInfo.data || []).filter((c) =>
      rawCategories.some((val) => String(typeof val === 'object' ? val.id : val) === String(c.id))
    );
    const resolvedProducts = (productsInfo.data || []).filter((p) =>
      rawProducts.some((val) => String(typeof val === 'object' ? val.id : val) === String(p.id))
    );
    const resolvedServices = (servicesInfo.data || []).filter((s) =>
      rawServices.some((val) => String(typeof val === 'object' ? val.id : val) === String(s.id))
    );

    return {
      ...values,
      interestFree: Number(values.interestFree) === 1,
      value: values.currentValue,
      isActive: Number(values.isActive) === 1,
      isPublic: isPub,
      customerProfile: isPub ? 1 : values.customerProfile,
      catalogPublication: isPub ? 'public' : isCoup ? 'coupon' : 'none',
      couponCode: values.couponCode || '',
      discountType: isPct ? 'percentage' : 'discount',
      percentage: values.percentage !== undefined && values.percentage !== null && Number(values.percentage) > 0 ? values.percentage : '',
      discount: values.discount !== undefined && values.discount !== null && Number(values.discount) > 0 ? values.discount : '',
      minValue: values.minValue !== undefined && values.minValue !== null && Number(values.minValue) > 0 ? values.minValue : '',
      maxDiscount: values.maxDiscount !== undefined && values.maxDiscount !== null && Number(values.maxDiscount) > 0 ? values.maxDiscount : '',
      startDate: formatDateTimeLocal(values.startDate),
      endDate: formatDateTimeLocal(values.endDate),
      usageLimit: values.usageLimit !== undefined && values.usageLimit !== null && Number(values.usageLimit) > 0 ? values.usageLimit : '',
      minQuantity: values.minQuantity !== undefined && values.minQuantity !== null && Number(values.minQuantity) > 0 ? values.minQuantity : '',
      usageCount: values.usageCount || 0,
      paymentMethods: resolvedPaymentMethods.length > 0 ? resolvedPaymentMethods : payMethods,
      categories: resolvedCategories.length > 0 ? resolvedCategories : rawCategories.map((id) => (typeof id === 'object' ? id : { id, name: `Categoria #${id}` })),
      products: resolvedProducts.length > 0 ? resolvedProducts : rawProducts.map((id) => (typeof id === 'object' ? id : { id, name: `Produto #${id}` })),
      services: resolvedServices.length > 0 ? resolvedServices : rawServices.map((id) => (typeof id === 'object' ? id : { id, name: `Serviço #${id}` })),
    };
  };

  const handleClickRight = (event, values) => {
    event.preventDefault();
    setModalValues(parsePromoValues(values));
    setClickRight({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };
  const handleCloseClickRight = () => {
    setClickRight(initialClick);
  };

  // ação para click esquerdo
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickLeft = (event, values) => {
    setModalValues(parsePromoValues(values));
    setAnchorEl(event.currentTarget);
  };

  const handleCloseClickLeft = () => {
    setAnchorEl(null);
  };

  const [filterLoad, filterInfo] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/promotions',
    headers: {
      sessionToken: credencials.sessionToken,
      company: credencials.company,
    },
  });

  const [activeLoad, activeInfo, setActiveInfo] = useApi({
    method: 'patch',
    url: '/promotions',
    headers: {
      sessionToken: credencials.sessionToken,
      company: credencials.company,
    },
    onCompleted: (response) => {
      if (response) {
        filterLoad({
          params: search,
        });
      }
    },
  });

  const [updateLoad, updateInfo, setUpdateInfo] = useApi({
    method: 'put',
    url: '/promotions',
    headers: {
      sessionToken: credencials.sessionToken,
      company: credencials.company,
    },
    onCompleted: (response) => {
      if (response) {
        filterLoad({
          params: search,
        });
      }
    },
  });

  const [clientLoad, clientInfo] = useApi({
    method: 'get',
    url: '/customers/profiles',
    headers: {
      sessionToken: credencials.sessionToken,
      company: credencials.company,
    },
  });

  useEffect(() => {
    clientLoad();
    categoriesLoad();
    paymentsLoad();
    productsLoad();
    servicesLoad();
    filterLoad({
      params: { isActive: 1 },
    });
  }, []);

  function handleModalFilter() {
    setFilter(!filter);
  }

  function handleModalUpdate(values, isClick) {
    if (values) {
      setModalValues(parsePromoValues(values));
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setModalTab(0);
    setView(!view);
  }

  function handleModalAcive(values, isClick) {
    if (values) {
      setModalValues({
        id: values.id,
        isActive: values.interestFree,
        name: values.name,
      });
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setModalActive(true);
  }

  function closeAlert(event, reason) {
    setUpdateInfo();
    setActiveInfo();
    if (reason === 'clickaway') {
      return;
    }
    setAlert(false);
  }

  function onSubmit(values) {
    const searchValues = {
      ...values,
      isActive: (values.showCloseAll && '0') || (!isActive && 1),
      showCloseAll: '',
    };
    filterLoad({
      debounced: true,
      params: emptyObject(searchValues),
    });
    setSearch(emptyObject(searchValues));
  }

  function onInactive(actived) {
    const searchValues = {
      ...search,
      isActive: !actived && 1,
    };
    filterLoad({
      params: emptyObject(searchValues),
    });
    setIsActive(actived);
    setSearch(emptyObject(searchValues));
  }

  function onUpdate(values) {
    if (values.startDate && values.endDate) {
      if (new Date(values.endDate) <= new Date(values.startDate)) {
        alert('A data de término da vigência deve ser posterior à data de início.');
        return;
      }
    }

    const isPub = values.catalogPublication === 'public';
    const isCoup = values.catalogPublication === 'coupon';

    const isPct = values.discountType === 'percentage';
    const finalPercentage = isPct ? Number(values.percentage) || 0 : 0;
    const finalDiscount = !isPct ? Number(values.discount) || 0 : 0;

    const hasCats = values.categories && values.categories.length > 0;

    const payload = {
      id: values.id,
      name: values.name,
      description: values.description,
      customerProfile: isPub ? 1 : values.customerProfile,
      percentage: finalPercentage,
      discount: finalDiscount,
      minValue: values.minValue !== '' && values.minValue !== null ? Number(values.minValue) : null,
      maxDiscount: values.maxDiscount !== '' && values.maxDiscount !== null ? Number(values.maxDiscount) : null,
      startDate: values.startDate ? values.startDate : null,
      endDate: values.endDate ? values.endDate : null,
      usageLimit: values.usageLimit !== '' && values.usageLimit !== null ? parseInt(values.usageLimit, 10) : null,
      minQuantity: values.minQuantity !== '' && values.minQuantity !== null ? parseInt(values.minQuantity, 10) : null,
      categories: hasCats ? (values.categories || []).map((c) => (typeof c === 'object' ? c.id : c)) : [],
      products: !hasCats ? (values.products || []).map((p) => (typeof p === 'object' ? p.id : p)) : [],
      services: !hasCats ? (values.services || []).map((s) => (typeof s === 'object' ? s.id : s)) : [],
      isPublic: isPub,
      couponCode: isCoup && values.couponCode ? values.couponCode.trim().toUpperCase() : null,
      paymentMethods: values.paymentMethods
        ? values.paymentMethods.map((p) => (typeof p === 'object' ? p.id : p))
        : [],
      isActive: values.isActive ? 1 : 0,
    };

    updateLoad({
      data: payload,
    });
    setView(false);
    setAlert(true);
  }

  function onActive() {
    const data = {
      id: modalValues.id,
    };
    activeLoad({
      data,
    });
    setModalActive(false);
    setAlertActive(true);
  }

  function generateRandomCoupon() {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let code = 'DUZZ';
    for (let i = 0; i < 4; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  }

  const externalPaymentMethods = paymentsInfo.data
    ? paymentsInfo.data.filter((pm) => Number(pm.is_internal) !== 1)
    : [];

  return (
    <>
      <Formik onSubmit={onSubmit} initialValues={initialState}>
        {({ values, submitForm, setFieldValue }) => (
          <Form onChange={submitForm}>
            <UIContainer container direction="row">
              <Grid
                item
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                xs={12}
              >
                <UIFormTitle title="Filtrar promoções" />
                <UIFilter onClick={handleModalFilter} />
              </Grid>
              <Hidden smDown>
                <Grid item md={1}>
                  <Field
                    name="id"
                    label="ID"
                    placeholder="ID"
                    fullWidth
                    as={TextField}
                  />
                </Grid>
              </Hidden>

              <Grid item xs={6} md={3}>
                <Field
                  name="name"
                  label="Nome"
                  placeholder="Nome da promoção"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Hidden smDown>
                <Grid item xs={6} md={4}>
                  <Field
                    name="description"
                    label="Descrição"
                    placeholder="Descrição da promoção"
                    fullWidth
                    as={TextField}
                  />
                </Grid>
              </Hidden>

              <Grid item xs={6} md={3}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Ver promoções</FormLabel>
                  <FormGroup row>
                    <FormControlLabel
                      label="Sem juros"
                      labelPlacement="start"
                      control={
                        <Checkbox
                          checked={values.interestFree}
                          onChange={(ev) =>
                            setFieldValue('interestFree', ev.target.checked)
                          }
                        />
                      }
                    />
                    <Hidden smDown>
                      <FormControlLabel
                        label="Inativas"
                        labelPlacement="start"
                        control={
                          <Checkbox
                            checked={values.userId}
                            onChange={(ev) =>
                              setFieldValue('userId', ev.target.checked)
                            }
                          />
                        }
                      />
                    </Hidden>
                  </FormGroup>
                </FormControl>
              </Grid>

              <Hidden smDown>
                <UIButtonSearch xs={1} />
              </Hidden>
            </UIContainer>

            <UIModalFilter
              open={filter}
              changeModal={handleModalFilter}
              submit={submitForm}
              fullWidth
            >
              <Hidden mdUp>
                <Grid item xs={12}>
                  <Field
                    name="id"
                    label="ID"
                    placeholder="ID"
                    fullWidth
                    as={TextField}
                  />
                </Grid>
              </Hidden>
              <Grid item xs={12}>
                <Field
                  name="percentage"
                  label="Porcentagem"
                  placeholder="Informe a porcentagem do desconto"
                  type="number"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  name="products"
                  label="Produtos"
                  placeholder="Informe o nome do produto"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  name="services"
                  label="Serviços"
                  placeholder="Informe o nome do serviço"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <FormControl component="fieldset">
                <FormLabel component="legend">Ver promoções</FormLabel>
                <FormGroup row>
                  <FormControlLabel
                    label="Somente inativas"
                    labelPlacement="start"
                    control={
                      <Checkbox
                        checked={values.showCloseAll}
                        onChange={(ev) =>
                          setFieldValue('showCloseAll', ev.target.checked)
                        }
                      />
                    }
                  />
                </FormGroup>
              </FormControl>
            </UIModalFilter>
          </Form>
        )}
      </Formik>

      <UIContainer>
        <Grid
          item
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          xs={12}
        >
          <UIFormTitle title="Lista de promoções" />
          <FormControlLabel
            label={
              isActive
                ? 'Esconder promoções inativas'
                : 'Mostrar promoções inativas'
            }
            labelPlacement="start"
            control={
              <GreenSwitch
                checked={isActive}
                onChange={(ev) => onInactive(ev.target.checked)}
              />
            }
          />
        </Grid>
        <Grid item xs style={{ marginTop: '15px' }}>
          {/* Tabela Desktop */}
          <Hidden smDown>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell>Descrição</TableCell>
                    <TableCell>Publicação na Loja</TableCell>
                    <TableCell>Desconto</TableCell>
                    <TableCell>Valor Mínimo</TableCell>
                    <TableCell>Vigência / Usos</TableCell>
                    <TableCell>Sem Juros</TableCell>
                    <TableCell align="right">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterInfo.loading && <CircularProgress />}
                  {filterInfo.data &&
                    filterInfo.data.map((data) => {
                      const isPub = data.isPublic === 1 || data.isPublic === true || data.isPublic === '1';
                      const hasCoupon = Boolean(data.couponCode && String(data.couponCode).trim());
                      const hasPct = Number(data.percentage) > 0;
                      const hasFixed = Number(data.discount) > 0;
                      const hasMinVal = Number(data.minValue) > 0;

                      let rawCats = [];
                      try {
                        rawCats = Array.isArray(data.categories) ? data.categories : (typeof data.categories === 'string' ? JSON.parse(data.categories || '[]') : []);
                      } catch (e) {
                        rawCats = [];
                      }
                      let rawProds = [];
                      try {
                        rawProds = Array.isArray(data.products) ? data.products : (typeof data.products === 'string' ? JSON.parse(data.products || '[]') : []);
                      } catch (e) {
                        rawProds = [];
                      }
                      let rawServs = [];
                      try {
                        rawServs = Array.isArray(data.services) ? data.services : (typeof data.services === 'string' ? JSON.parse(data.services || '[]') : []);
                      } catch (e) {
                        rawServs = [];
                      }

                      const parseDateHelper = (dateStr) => {
                        if (!dateStr) return null;
                        try {
                          const str = String(dateStr).trim();
                          if (/^\d{2}[-/]\d{2}[-/]\d{4}/.test(str)) {
                            const [datePart, timePart] = str.split(' ');
                            const [day, month, year] = datePart.split(/[-/]/);
                            return new Date(`${year}-${month}-${day}T${timePart || '00:00:00'}`);
                          }
                          return new Date(str);
                        } catch (e) {
                          return null;
                        }
                      };

                      const now = new Date();
                      const startDt = parseDateHelper(data.startDate);
                      const endDt = parseDateHelper(data.endDate);
                      const isFuture = Boolean(data.isFuture || (startDt && !isNaN(startDt.getTime()) && startDt > now));
                      const isExpired = Boolean(data.isExpired || (endDt && !isNaN(endDt.getTime()) && endDt < now));
                      const isLimitReached = Boolean(data.isLimitReached);

                      return (
                        <TableRow
                          hover
                          onDoubleClick={() => handleModalUpdate(data)}
                          onContextMenu={
                            !mobile ? (ev) => handleClickRight(ev, data) : undefined
                          }
                          style={{
                            cursor: 'context-menu',
                          }}
                          onClick={
                            mobile ? (ev) => handleClickLeft(ev, data) : undefined
                          }
                          key={data.id}
                        >
                          <TableCell component="th" scope="row">
                            {data.id}
                          </TableCell>
                          <TableCell style={{ fontWeight: 600 }}>
                            {data.name}
                            <Box mt={0.5} display="flex" flexWrap="wrap" gridGap={4}>
                              {rawCats && rawCats.length > 0 ? (
                                <Chip
                                  label={`${rawCats.length} Categoria(s)`}
                                  size="small"
                                  style={{ backgroundColor: '#FEF3C7', color: '#B45309', fontWeight: 600, height: 20, fontSize: '0.7rem' }}
                                />
                              ) : (rawProds.length > 0 || rawServs.length > 0) ? (
                                <Chip
                                  label={`${rawProds.length + rawServs.length} Item(ns)`}
                                  size="small"
                                  style={{ backgroundColor: '#EDE9FE', color: '#6D28D9', fontWeight: 600, height: 20, fontSize: '0.7rem' }}
                                />
                              ) : (
                                <Chip
                                  label="Todos os Itens"
                                  size="small"
                                  style={{ backgroundColor: '#F1F5F9', color: '#475569', fontWeight: 500, height: 20, fontSize: '0.7rem' }}
                                />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell>{data.description || '-'}</TableCell>
                          <TableCell>
                            {isPub ? (
                              <Chip
                                label="Oferta Pública"
                                size="small"
                                style={{ backgroundColor: '#E0F2FE', color: '#0369A1', fontWeight: 600 }}
                              />
                            ) : hasCoupon ? (
                              <Chip
                                label={`Cupom: ${data.couponCode}`}
                                size="small"
                                style={{ backgroundColor: '#F3E8FF', color: '#7E22CE', fontWeight: 600 }}
                              />
                            ) : (
                              <Chip
                                label="Apenas PDV"
                                size="small"
                                style={{ backgroundColor: '#F1F5F9', color: '#64748B', fontWeight: 500 }}
                              />
                            )}
                          </TableCell>
                          <TableCell>
                            {hasPct ? (
                              <Chip
                                label={`${data.percentage}% OFF`}
                                size="small"
                                style={{ backgroundColor: '#E0F2FE', color: '#0284C7', fontWeight: 700 }}
                              />
                            ) : hasFixed ? (
                              <Chip
                                label={`R$ ${Number(data.discount).toFixed(2)} OFF`}
                                size="small"
                                style={{ backgroundColor: '#DCFCE7', color: '#16A34A', fontWeight: 700 }}
                              />
                            ) : (
                              <Typography variant="body2" color="textSecondary">Sem desconto</Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            {hasMinVal ? (
                              <Typography variant="body2" style={{ fontWeight: 600, color: '#334155' }}>
                                R$ {Number(data.minValue).toFixed(2)}
                              </Typography>
                            ) : (
                              <Typography variant="body2" color="textSecondary">-</Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            <Box display="flex" flexDirection="column" gridGap={2}>
                              {data.usageLimit ? (
                                <Typography variant="caption" style={{ color: isLimitReached ? '#DC2626' : '#475569' }}>
                                  Usos: {data.usageCount || 0} / {data.usageLimit}
                                </Typography>
                              ) : (
                                <Typography variant="caption" color="textSecondary">
                                  Usos: {data.usageCount || 0}
                                </Typography>
                              )}
                              {isFuture && (
                                <Chip
                                  label="Agendada"
                                  size="small"
                                  style={{ backgroundColor: '#E0E7FF', color: '#4338CA', fontWeight: 600, height: 20 }}
                                />
                              )}
                              {isExpired && (
                                <Chip
                                  label="Expirada"
                                  size="small"
                                  style={{ backgroundColor: '#FEE2E2', color: '#DC2626', fontWeight: 600, height: 20 }}
                                />
                              )}
                              {isLimitReached && (
                                <Chip
                                  label="Esgotada"
                                  size="small"
                                  style={{ backgroundColor: '#FEF2F2', color: '#B91C1C', fontWeight: 600, height: 20 }}
                                />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell>
                            {data.interestFree === '1' ? 'Sim' : 'Não'}
                          </TableCell>
                          <TableCell align="right">
                            <Tooltip title="Mais detalhes">
                              <IconButton
                                size="small"
                                onClick={() => handleModalUpdate(data)}
                              >
                                <SearchIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={Number(data.isActive) === 1 ? 'Desativar' : 'Ativar'}>
                              <Switch
                                size="small"
                                onClick={() => handleModalAcive(data)}
                                color="primary"
                                checked={Number(data.isActive) === 1}
                              />
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  <Menu
                    keepMounted
                    open={clickRight.mouseY !== null}
                    onClose={handleCloseClickRight}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      clickRight.mouseY !== null && clickRight.mouseX !== null
                        ? {
                          top: clickRight.mouseY,
                          left: clickRight.mouseX,
                        }
                        : undefined
                    }
                  >
                    <MenuItem onClick={() => handleModalUpdate(null, true)}>
                      Visualizar/Editar
                    </MenuItem>
                    {Number(modalValues.isActive) === 1 && (
                      <MenuItem onClick={() => handleModalAcive(null, true)}>
                        Ativar/desativar promoção
                      </MenuItem>
                    )}
                  </Menu>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={() => handleCloseClickLeft()}
                  >
                    <MenuItem onClick={() => handleModalUpdate(null, true)}>
                      Visualizar/Editar
                    </MenuItem>
                    {Number(modalValues.isActive) === 1 && (
                      <MenuItem onClick={() => handleModalAcive(null, true)}>
                        Ativar/desativar promoção
                      </MenuItem>
                    )}
                  </Menu>
                  {filterInfo.error && (
                    <TableRow>
                      <TableCell colSpan={8}>Sem resultados encontrados</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Hidden>

          {/* Listagem em Cards Mobile */}
          <Hidden mdUp>
            <Box style={{ width: '100%' }}>
              {filterInfo.loading && (
                <CircularProgress style={{ margin: '16px auto', display: 'block' }} />
              )}
              {filterInfo.data &&
                filterInfo.data.map((data) => {
                  const isPromoActive = Number(data.isActive) === 1;
                  const isPub = data.isPublic === 1 || data.isPublic === true || data.isPublic === '1';
                  const hasCoupon = Boolean(data.couponCode && String(data.couponCode).trim());

                  let rawCats = [];
                  try {
                    rawCats = Array.isArray(data.categories) ? data.categories : (typeof data.categories === 'string' ? JSON.parse(data.categories || '[]') : []);
                  } catch (e) {
                    rawCats = [];
                  }
                  let rawProds = [];
                  try {
                    rawProds = Array.isArray(data.products) ? data.products : (typeof data.products === 'string' ? JSON.parse(data.products || '[]') : []);
                  } catch (e) {
                    rawProds = [];
                  }
                  let rawServs = [];
                  try {
                    rawServs = Array.isArray(data.services) ? data.services : (typeof data.services === 'string' ? JSON.parse(data.services || '[]') : []);
                  } catch (e) {
                    rawServs = [];
                  }

                  return (
                    <Card
                      key={data.id}
                      variant="outlined"
                      style={{
                        marginBottom: 12,
                        borderLeft: `4px solid ${isPromoActive ? '#17497F' : '#9E9E9E'}`,
                        borderRadius: 8,
                        backgroundColor: isPromoActive ? '#FFFFFF' : '#FAFAFA',
                      }}
                    >
                      <CardContent style={{ paddingBottom: 8 }}>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mb={1}
                        >
                          <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                            #{data.id} - {data.name}
                          </Typography>
                          <Chip
                            label={isPromoActive ? 'Ativa' : 'Inativa'}
                            size="small"
                            style={{
                              backgroundColor: isPromoActive ? '#E8F5E9' : '#F5F5F5',
                              color: isPromoActive ? '#2E7D32' : '#757575',
                              fontWeight: 600,
                            }}
                          />
                        </Box>
                        <Box mb={1} display="flex" flexWrap="wrap" gridGap={4}>
                          {isPub ? (
                            <Chip
                              label="Oferta Pública"
                              size="small"
                              style={{ backgroundColor: '#E0F2FE', color: '#0369A1', fontWeight: 600 }}
                            />
                          ) : hasCoupon ? (
                            <Chip
                              label={`Cupom: ${data.couponCode}`}
                              size="small"
                              style={{ backgroundColor: '#F3E8FF', color: '#7E22CE', fontWeight: 600 }}
                            />
                          ) : (
                            <Chip
                              label="Apenas PDV"
                              size="small"
                              style={{ backgroundColor: '#F1F5F9', color: '#64748B', fontWeight: 500 }}
                            />
                          )}
                          {rawCats && rawCats.length > 0 ? (
                            <Chip
                              label={`${rawCats.length} Categoria(s)`}
                              size="small"
                              style={{ backgroundColor: '#FEF3C7', color: '#B45309', fontWeight: 600 }}
                            />
                          ) : (rawProds.length > 0 || rawServs.length > 0) ? (
                            <Chip
                              label={`${rawProds.length + rawServs.length} Item(ns)`}
                              size="small"
                              style={{ backgroundColor: '#EDE9FE', color: '#6D28D9', fontWeight: 600 }}
                            />
                          ) : (
                            <Chip
                              label="Todos os Itens"
                              size="small"
                              style={{ backgroundColor: '#F1F5F9', color: '#475569', fontWeight: 500 }}
                            />
                          )}
                          {Number(data.percentage) > 0 ? (
                            <Chip
                              label={`${data.percentage}% OFF`}
                              size="small"
                              style={{ backgroundColor: '#E0F2FE', color: '#0284C7', fontWeight: 700 }}
                            />
                          ) : Number(data.discount) > 0 ? (
                            <Chip
                              label={`R$ ${Number(data.discount).toFixed(2)} OFF`}
                              size="small"
                              style={{ backgroundColor: '#DCFCE7', color: '#16A34A', fontWeight: 700 }}
                            />
                          ) : null}
                          {data.isExpired && (
                            <Chip
                              label="Expirada"
                              size="small"
                              style={{ backgroundColor: '#FEE2E2', color: '#DC2626', fontWeight: 600 }}
                            />
                          )}
                        </Box>
                        {data.description && (
                          <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                            {data.description}
                          </Typography>
                        )}
                        <Divider style={{ margin: '8px 0' }} />
                        <Grid container spacing={1}>
                          <Grid item xs={4}>
                            <Typography variant="caption" color="textSecondary" display="block">
                              Valor Mínimo
                            </Typography>
                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                              {Number(data.minValue) > 0 ? `R$ ${Number(data.minValue).toFixed(2)}` : 'Nenhum'}
                            </Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography variant="caption" color="textSecondary" display="block">
                              Usos Realizados
                            </Typography>
                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                              {data.usageCount || 0} {data.usageLimit ? `/ ${data.usageLimit}` : ''}
                            </Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography variant="caption" color="textSecondary" display="block">
                              Sem Juros
                            </Typography>
                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                              {data.interestFree === '1' ? 'Sim' : 'Não'}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                      <CardActions style={{ justifyContent: 'flex-end', paddingTop: 0 }}>
                        <Button
                          size="small"
                          color="primary"
                          onClick={() => handleModalUpdate(data)}
                        >
                          Ver Detalhes
                        </Button>
                        <Button
                          size="small"
                          color={isPromoActive ? 'secondary' : 'default'}
                          onClick={() => handleModalAcive(data)}
                        >
                          {isPromoActive ? 'Desativar' : 'Ativar'}
                        </Button>
                      </CardActions>
                    </Card>
                  );
                })}
              {filterInfo.error && (
                <Typography color="textSecondary" align="center" style={{ padding: '16px 0' }}>
                  Sem resultados encontrados
                </Typography>
              )}
            </Box>
          </Hidden>
        </Grid>
      </UIContainer>

      {/* Modal Visualizar / Editar */}
      {modalValues && (
        <Dialog
          open={view}
          onClose={() => handleModalUpdate()}
          aria-labelledby="form-dialog-title"
          maxWidth="md"
          fullWidth
          fullScreen={mobile}
          classes={{ paper: classes.dialogPaper }}
        >
          <Formik
            enableReinitialize
            onSubmit={onUpdate}
            validationSchema={validationSchema}
            initialValues={modalValues}
          >
            {({ values, touched, errors, submitForm, setFieldValue }) => (
              <Form>
                <UIDialogTitle
                  id="form-dialog-title"
                  onClose={() => handleModalUpdate()}
                >
                  Gerenciar Promoção: {modalValues.name || ''}
                </UIDialogTitle>

                <Box borderBottom={1} borderColor="divider" bgcolor="#fbfcfd">
                  <Tabs
                    value={modalTab}
                    onChange={(e, val) => setModalTab(val)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                  >
                    <Tab
                      className={classes.tabRoot}
                      icon={<LocalOfferIcon fontSize="small" />}
                      label="Geral & Desconto"
                    />
                    <Tab
                      className={classes.tabRoot}
                      icon={<CategoryIcon fontSize="small" />}
                      label="Itens Elegíveis"
                    />
                    <Tab
                      className={classes.tabRoot}
                      icon={<TuneIcon fontSize="small" />}
                      label="Regras & Vigência"
                    />
                    <Tab
                      className={classes.tabRoot}
                      icon={<StorefrontIcon fontSize="small" />}
                      label="Loja Virtual"
                    />
                  </Tabs>
                </Box>

                <DialogContent className={classes.dialogContentStable}>
                  {/* ABA 0: GERAL & DESCONTO */}
                  {modalTab === 0 && (
                    <Grid container direction="row" spacing={2}>
                      <Grid item xs={12} md={8}>
                        <Field
                          name="name"
                          label="Nome da Promoção"
                          placeholder="Informe o nome da promoção"
                          fullWidth
                          as={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <FormControlLabel
                          label={
                            values.isActive
                              ? 'Promoção ativa'
                              : 'Promoção inativa'
                          }
                          labelPlacement="top"
                          control={
                            <GreenSwitch
                              checked={values.isActive}
                              onChange={(ev) => setFieldValue('isActive', ev.target.checked)}
                            />
                          }
                        />
                      </Grid>
                      <Grid item xs={12} md={8}>
                        <Field
                          name="description"
                          label="Descrição (Opcional)"
                          placeholder="Descrição da promoção"
                          fullWidth
                          as={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                          <InputLabel
                            shrink
                            id="promotion-search-customerProfile"
                          >
                            Perfil do cliente
                          </InputLabel>
                          <Field
                            name="customerProfile"
                            disabled={clientInfo.loading || values.catalogPublication === 'public'}
                            error={Boolean(errors.customerProfile)}
                            helperText={
                              values.catalogPublication === 'public'
                                ? 'Ofertas públicas se aplicam obrigatoriamente ao perfil padrão (1).'
                                : (touched.customerProfile && errors.customerProfile)
                            }
                            labelId="promotion-search-customerProfile"
                            displayEmpty
                            fullWidth
                            as={Select}
                            value={values.catalogPublication === 'public' ? 1 : values.customerProfile}
                          >
                            <MenuItem disabled value="">
                              <em>Selecione o perfil do cliente</em>
                            </MenuItem>
                            {clientInfo.data !== null &&
                              clientInfo.data.map((client) => (
                                <MenuItem key={client.id} value={client.id}>
                                  {client.name}
                                </MenuItem>
                              ))}
                          </Field>
                        </FormControl>
                      </Grid>

                      {/* Seletor Claro de Tipo de Desconto */}
                      <Grid item xs={12} md={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend" style={{ fontSize: '0.85rem', color: '#17497F', fontWeight: 600 }}>
                            Tipo de Desconto Concedido
                          </FormLabel>
                          <RadioGroup
                            row
                            value={values.discountType || 'percentage'}
                            onChange={(ev) => {
                              const newType = ev.target.value;
                              setFieldValue('discountType', newType);
                              if (newType === 'percentage') {
                                setFieldValue('discount', '');
                              } else {
                                setFieldValue('percentage', '');
                                setFieldValue('maxDiscount', '');
                              }
                            }}
                          >
                            <FormControlLabel
                              value="percentage"
                              control={<Radio color="primary" />}
                              label="Porcentagem (%)"
                            />
                            <FormControlLabel
                              value="discount"
                              control={<Radio color="primary" />}
                              label="Valor Fixo (R$)"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend" style={{ fontSize: '0.85rem', color: '#17497F', fontWeight: 600 }}>
                            Remover juros no parcelamento?
                          </FormLabel>
                          <RadioGroup
                            row
                            value={String(values.interestFree)}
                            onChange={(ev) => setFieldValue('interestFree', ev.target.value === 'true')}
                          >
                            <FormControlLabel value="true" control={<Radio />} label="Sim" />
                            <FormControlLabel value="false" control={<Radio />} label="Não" />
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      {/* Campo Contextual de Desconto */}
                      {values.discountType === 'percentage' ? (
                        <>
                          <Grid item xs={12} md={6}>
                            <Field
                              name="percentage"
                              label="Desconto em Porcentagem (%)"
                              error={Boolean(errors.percentage)}
                              helperText={
                                (touched.percentage && errors.percentage) ||
                                'Aplica % de desconto sobre o valor dos itens participantes.'
                              }
                              placeholder="Ex: 10 (para 10% de desconto)"
                              type="number"
                              inputProps={{ min: 0, max: 100, step: 'any' }}
                              fullWidth
                              as={TextField}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Field
                              name="maxDiscount"
                              label="Teto Máximo de Desconto em R$ (Opcional)"
                              error={Boolean(errors.maxDiscount)}
                              helperText={
                                (touched.maxDiscount && errors.maxDiscount) ||
                                'Ex: 50.00. Limita o desconto máximo mesmo em compras grandes.'
                              }
                              placeholder="Sem limite de teto"
                              type="number"
                              inputProps={{ min: 0, step: 'any' }}
                              fullWidth
                              as={TextField}
                            />
                          </Grid>
                        </>
                      ) : (
                        <Grid item xs={12} md={6}>
                          <Field
                            name="discount"
                            label="Desconto Fixo (R$)"
                            error={Boolean(errors.discount)}
                            helperText={
                              (touched.discount && errors.discount) ||
                              'Abate este valor fixo do total dos itens participantes.'
                            }
                            placeholder="Ex: 15.00"
                            type="number"
                            inputProps={{ min: 0, step: 'any' }}
                            fullWidth
                            as={TextField}
                          />
                        </Grid>
                      )}
                    </Grid>
                  )}

                  {/* ABA 1: ITENS ELEGÍVEIS */}
                  {modalTab === 1 && (
                    <Grid container direction="row" spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 4 }}>
                          Defina os itens participantes. Ao selecionar categorias, todos os produtos e serviços vinculados a elas participarão automaticamente da promoção.
                        </Typography>
                      </Grid>

                      {/* Categorias */}
                      <Grid item xs={12}>
                        <Autocomplete
                          multiple
                          noOptionsText="Sem opções"
                          disabled={categoriesInfo.loading}
                          options={categoriesInfo.data || []}
                          getOptionSelected={(option, value) =>
                            String(option.id) === String(typeof value === 'object' ? value.id : value)
                          }
                          value={
                            values.categories && values.categories.length > 0
                              ? (categoriesInfo.data || []).filter((cat) =>
                                values.categories.some((val) => String(typeof val === 'object' ? val.id : val) === String(cat.id))
                              )
                              : []
                          }
                          getOptionLabel={(cat) => cat.name || `Categoria #${cat.id}`}
                          onChange={(event, selected) => {
                            setFieldValue('categories', selected);
                            if (selected && selected.length > 0) {
                              setFieldValue('products', []);
                              setFieldValue('services', []);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Categorias participantes (Opcional)"
                              placeholder={!values.categories || !values.categories.length ? 'Nenhuma categoria (Definir por produtos/serviços ou todos)' : 'Adicione mais categorias'}
                              helperText={
                                values.categories && values.categories.length > 0
                                  ? 'Categorias selecionadas. Os campos de produtos e serviços individuais foram desabilitados.'
                                  : 'Deixe vazio caso queira selecionar produtos ou serviços específicos abaixo.'
                              }
                              variant="standard"
                            />
                          )}
                        />
                      </Grid>

                      {/* Produtos */}
                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          multiple
                          noOptionsText="Sem opções"
                          disabled={productsInfo.loading || (values.categories && values.categories.length > 0)}
                          options={productsInfo.data || []}
                          getOptionSelected={(option, value) =>
                            String(option.id) === String(typeof value === 'object' ? value.id : value)
                          }
                          value={
                            values.products && values.products.length > 0
                              ? (productsInfo.data || []).filter((prod) =>
                                values.products.some((val) => String(typeof val === 'object' ? val.id : val) === String(prod.id))
                              )
                              : []
                          }
                          getOptionLabel={(product) => product.name || `Produto #${product.id}`}
                          onChange={(event, selected) => setFieldValue('products', selected)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Produtos participantes (Opcional)"
                              placeholder={
                                values.categories && values.categories.length > 0
                                  ? 'Desabilitado por categoria'
                                  : (!values.products || !values.products.length ? 'Válido para todos os produtos' : 'Adicione mais produtos')
                              }
                              helperText={
                                values.categories && values.categories.length > 0
                                  ? 'Desabilitado por categoria'
                                  : 'Deixe vazio para todos os produtos se não houver categoria.'
                              }
                              variant="standard"
                            />
                          )}
                        />
                      </Grid>

                      {/* Serviços */}
                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          multiple
                          noOptionsText="Sem opções"
                          disabled={servicesInfo.loading || (values.categories && values.categories.length > 0)}
                          options={servicesInfo.data || []}
                          getOptionSelected={(option, value) =>
                            String(option.id) === String(typeof value === 'object' ? value.id : value)
                          }
                          value={
                            values.services && values.services.length > 0
                              ? (servicesInfo.data || []).filter((serv) =>
                                values.services.some((val) => String(typeof val === 'object' ? val.id : val) === String(serv.id))
                              )
                              : []
                          }
                          getOptionLabel={(service) => service.name || `Serviço #${service.id}`}
                          onChange={(event, selected) => setFieldValue('services', selected)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Serviços participantes (Opcional)"
                              placeholder={
                                values.categories && values.categories.length > 0
                                  ? 'Desabilitado por categoria'
                                  : (!values.services || !values.services.length ? 'Válido para todos os serviços' : 'Adicione mais serviços')
                              }
                              helperText={
                                values.categories && values.categories.length > 0
                                  ? 'Desabilitado por categoria'
                                  : 'Deixe vazio para todos os serviços se não houver categoria.'
                              }
                              variant="standard"
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  )}

                  {/* ABA 2: REGRAS & VIGÊNCIA */}
                  {modalTab === 2 && (
                    <Grid container direction="row" spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Field
                          name="minValue"
                          label="Valor Mínimo da Compra (R$) - Opcional"
                          error={Boolean(errors.minValue)}
                          helperText={
                            (touched.minValue && errors.minValue) ||
                            'O pedido deve atingir ao menos este valor para liberar a promoção.'
                          }
                          placeholder="Ex: 50.00"
                          type="number"
                          inputProps={{ min: 0, step: 'any' }}
                          fullWidth
                          as={TextField}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Field
                          name="minQuantity"
                          label="Quantidade Mínima de Itens - Opcional"
                          error={Boolean(errors.minQuantity)}
                          helperText={
                            (touched.minQuantity && errors.minQuantity) ||
                            'Quantidade mínima de itens participantes exigida.'
                          }
                          placeholder="Ex: 2"
                          type="number"
                          inputProps={{ min: 1, step: 1 }}
                          fullWidth
                          as={TextField}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Field
                          name="usageLimit"
                          label="Limite Máximo de Usos"
                          placeholder="Ex: 100"
                          type="number"
                          inputProps={{ min: 1, step: 1 }}
                          fullWidth
                          as={TextField}
                          helperText={values.usageCount ? `Usos realizados até o momento: ${values.usageCount}` : 'Uso ilimitado se vazio'}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Field
                          name="startDate"
                          label="Início da Vigência"
                          type="datetime-local"
                          InputLabelProps={{ shrink: true }}
                          error={Boolean(errors.startDate)}
                          helperText={touched.startDate && errors.startDate}
                          fullWidth
                          as={TextField}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Field
                          name="endDate"
                          label="Término da Vigência"
                          type="datetime-local"
                          InputLabelProps={{ shrink: true }}
                          error={Boolean(errors.endDate)}
                          helperText={touched.endDate && errors.endDate}
                          fullWidth
                          as={TextField}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Autocomplete
                          multiple
                          noOptionsText="Sem opções"
                          disabled={paymentsInfo.loading}
                          options={externalPaymentMethods}
                          getOptionSelected={(option, value) =>
                            String(option.id) === String(typeof value === 'object' ? value.id : value)
                          }
                          value={
                            values.paymentMethods && values.paymentMethods.length > 0
                              ? externalPaymentMethods.filter((pm) =>
                                values.paymentMethods.some((val) => String(typeof val === 'object' ? val.id : val) === String(pm.id))
                              )
                              : []
                          }
                          getOptionLabel={(option) => option.name || `Forma #${option.id}`}
                          onChange={(event, selected) => setFieldValue('paymentMethods', selected)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Limitar a certas formas de pagamento (Opcional)"
                              placeholder={!values.paymentMethods || !values.paymentMethods.length ? 'Válido para todas as formas de pagamento' : 'Adicione mais'}
                              helperText="Selecione caso a promoção ou cupom só tenha validade para pagamentos específicos (ex: PIX)."
                              variant="standard"
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  )}

                  {/* ABA 3: LOJA VIRTUAL */}
                  {modalTab === 3 && (
                    <Grid container direction="row" spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 4 }}>
                          Toda promoção criada é válida para uso manual no PDV. Escolha abaixo como ela será disponibilizada na vitrine online:
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend" style={{ fontSize: '0.85rem', color: '#17497F', fontWeight: 600 }}>
                            Modo de Publicação
                          </FormLabel>
                          <RadioGroup
                            value={values.catalogPublication || 'none'}
                            onChange={(ev) => {
                              const mode = ev.target.value;
                              setFieldValue('catalogPublication', mode);
                              if (mode === 'public') {
                                setFieldValue('customerProfile', 1);
                              }
                              if (mode !== 'coupon') {
                                setFieldValue('couponCode', '');
                              }
                            }}
                          >
                            <FormControlLabel
                              value="none"
                              control={<Radio color="primary" />}
                              label="Não publicar na loja (Uso manual no PDV)"
                            />
                            <FormControlLabel
                              value="public"
                              control={<Radio color="primary" />}
                              label="Oferta Pública (Exibe na vitrine com desconto)"
                            />
                            <FormControlLabel
                              value="coupon"
                              control={<Radio color="primary" />}
                              label="Cupom de Desconto (Exige código do cliente)"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      {values.catalogPublication === 'coupon' && (
                        <Grid item xs={12} md={6} container spacing={1} alignItems="center">
                          <Grid item xs={8}>
                            <Field
                              name="couponCode"
                              label="Código do Cupom"
                              placeholder="Ex: VERAO10"
                              fullWidth
                              as={TextField}
                              inputProps={{ style: { textTransform: 'uppercase' } }}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={() => setFieldValue('couponCode', generateRandomCoupon())}
                            >
                              Gerar Código
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  )}
                </DialogContent>
                <DialogActions
                  style={{
                    padding: '12px 24px',
                    backgroundColor: '#fbfcfd',
                    borderTop: '1px solid #e0e0e0',
                  }}
                >
                  <Button onClick={() => handleModalUpdate()} color="primary">
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                  >
                    Salvar Alterações
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </Dialog>
      )}

      <Dialog
        open={modalActive}
        onClose={() => setModalActive(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <UIDialogTitle id="alert-dialog-title">
          Deseja {modalValues.isActive === 1 ? 'ativar' : 'desativar'} a
          promoção {modalValues.name}?
        </UIDialogTitle>
        <DialogActions>
          <Button onClick={() => setModalActive(false)} color="primary">
            Não
          </Button>
          <Button onClick={onActive} color="primary" autoFocus>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <UIDialogConfirm
        open={alertActive}
        close={() => setAlertActive(false)}
        data={activeInfo}
        setrequestinfo={closeAlert}
        messageSucess={`Status da promoção alterado`}
        messageError="Ops, aconteceu algum problema, tente mais tarde"
        type="success"
      />
      <UIDialogConfirm
        open={alert}
        close={() => setAlert(false)}
        data={updateInfo}
        setrequestinfo={closeAlert}
        messageSucess="Promo atualizada com sucesso"
        messageError="Ops, aconteceu algum problema, tente mais tarde"
        type="success"
      />
    </>
  );
};

export default PromotionSearch;
